import { useCallback, useRef } from 'react';

interface Props {
  value: number; // 0..1
  onChange: (v: number) => void;
  className?: string;
}

/** Vertical fader with pointer-capture dragging. */
export function VSlider({ value, onChange, className = '' }: Props) {
  const trackRef = useRef<HTMLDivElement>(null);
  const dragging = useRef(false);

  const setFromPointer = useCallback(
    (clientY: number) => {
      const el = trackRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const v = 1 - (clientY - rect.top) / rect.height;
      onChange(Math.min(1, Math.max(0, v)));
    },
    [onChange],
  );

  return (
    <div
      ref={trackRef}
      className={`vslider ${className}`}
      onPointerDown={(e) => {
        dragging.current = true;
        e.currentTarget.setPointerCapture(e.pointerId);
        setFromPointer(e.clientY);
      }}
      onPointerMove={(e) => {
        if (dragging.current) setFromPointer(e.clientY);
      }}
      onPointerUp={() => {
        dragging.current = false;
      }}
    >
      <div className="vslider-track" />
      <div className="vslider-fill" style={{ height: `${value * 100}%` }} />
      <div className="vslider-handle" style={{ bottom: `calc(${value * 100}% - 5px)` }} />
    </div>
  );
}